/**
 * TanStack Query hooks for `customizable-campaign-alerts`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	customizableCampaignAlertsQueryKeys,
	type CreateCustomizableCampaignAlertsBody,
	type ListCustomizableCampaignAlertsResponse,
	type CustomizableCampaignAlertsRow,
} from "./api";

export function useCustomizableCampaignAlertsList(): UseQueryResult<ListCustomizableCampaignAlertsResponse, Error> {
	return useQuery({
		queryKey: customizableCampaignAlertsQueryKeys.list(),
		queryFn: list,
	});
}

export function useCustomizableCampaignAlertsCreate(): UseMutationResult<CustomizableCampaignAlertsRow, Error, CreateCustomizableCampaignAlertsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customizableCampaignAlertsQueryKeys.all });
		},
	});
}

export function useCustomizableCampaignAlertsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customizableCampaignAlertsQueryKeys.all });
		},
	});
}
